import DOMPurify from "dompurify";

// Renders admin-authored text that may be rich HTML (from the TipTap editor)
// or legacy plain text. Any HTML-like tag (p, span, div, a, figure, br, …)
// triggers safe HTML rendering so raw tags can never leak into the UI;
// plain text keeps its line breaks.
const looksHtml = (s) => typeof s === "string" && /<\/?[a-z][a-z0-9-]*(\s[^<>]*)?\/?>/i.test(s);

export default function RichText({ value, className = "" }) {
  if (!value) return null;
  if (looksHtml(value)) {
    const clean = DOMPurify.sanitize(value, {
      ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "s", "mark", "h2", "h3", "h4", "ul", "ol", "li", "blockquote", "a", "span", "div", "sub", "sup", "hr", "figure", "figcaption", "img"],
      ALLOWED_ATTR: ["href", "target", "rel", "style", "src", "alt", "class", "width", "height"],
    });
    return <div className={`prose-content ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
  }
  return <div className={`prose-content whitespace-pre-line ${className}`}>{value}</div>;
}
